import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Shield, Mail, Calendar, Globe } from 'lucide-react';
import { format } from 'date-fns';

interface Props {
  profile: {
    email: string;
    created_at: string;
    language: string;
  };
  role: string;
}

export function AccountInfoCard({ profile, role }: Props) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Shield className="h-5 w-5 text-primary" />
          {t('myProfile.accountInfo')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-3 sm:grid-cols-2">
          <div className="flex items-center gap-2 text-sm">
            <Mail className="h-4 w-4 text-muted-foreground" />
            <span>{profile.email}</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Calendar className="h-4 w-4 text-muted-foreground" />
            <span>{t('myProfile.memberSince')} {format(new Date(profile.created_at), 'MMM yyyy')}</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Globe className="h-4 w-4 text-muted-foreground" />
            <span>{t(`languages.${profile.language}`)}</span>
          </div>
          <div>
            <Badge variant="secondary" className="capitalize">{role}</Badge>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
